import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { LoaderComponent } from "./libs/components/loader/loader.component";

@Component({
  selector: "zelo-root",
  imports: [RouterOutlet, LoaderComponent],
  templateUrl: "./app.component.html",
  standalone: true
})
export class App {}
